import { func } from 'prop-types';
import React, { PureComponent } from 'react';

import { sportEvent } from 'calendar/proptypes';
import Button from 'shared/components/button/Button';
import Quote from 'shared/components/icon/Quote';
import Star from 'shared/components/icon/Star';
import ProductName from 'shared/components/ProductName';
import { formatCalendar } from 'shared/utils/dateUtils';
import { getProductDisplayName } from 'shared/utils/productUtils';
import { getText, uppperFirst } from 'shared/utils/Text';

export default class SportCalendarItem extends PureComponent {
  static propTypes = {
    event: sportEvent.isRequired,
    onClick: func.isRequired,
  };

  onClick = () => {
    const {
      event: { betParams },
      onClick,
    } = this.props;
    onClick(betParams);
  };

  render() {
    const {
      event: {
        betParams: { product },
        closeTime,
        jackpotAmount,
        hasJokerSportAnalysis,
        hasOveroddsAnalysis,
      },
    } = this.props;
    const hasAnalysis = hasJokerSportAnalysis || hasOveroddsAnalysis;
    return (
      <li className="sport-highlight-item">
        <Button
          onClick={this.onClick}
          className={`block-button block-button--bet bg-${getProductDisplayName(
            product,
          )} ${hasAnalysis ? 'block-button--analysis' : ''}`}
        >
          <div className="block-button__inner">
            <span className="block-button__left">
              <ProductName product={product} uppercase />
            </span>
            {jackpotAmount && (
              <span className="block-button__jackpot">
                <Star className="white" />
                <span className="jackpot-amount">
                  {getText('calendar-jackpot-button-value', jackpotAmount)}
                </span>
              </span>
            )}
            <span className="block-button__right">
              {uppperFirst(
                formatCalendar(closeTime, { showTimeForToday: true }),
              )}
            </span>
          </div>
          {hasAnalysis && (
            <div className="block-button__inner">
              <Quote className="white" />
              <span>{`${getText(
                'calendar-analysis-provider',
                `${
                  hasOveroddsAnalysis
                    ? getText('calendar-analysis-provider-overodds')
                    : getText('calendar-analysis-provider-jokersport')
                }`,
              )} ${
                hasJokerSportAnalysis && hasOveroddsAnalysis
                  ? ` ${getText('calendar-analysis-provider-secondary')}`
                  : ''
              }`}</span>
            </div>
          )}
        </Button>
      </li>
    );
  }
}
